import { render, staticRenderFns } from "./DynamicCohortPreview.vue?vue&type=template&id=10d08657&scoped=true&"
import script from "./DynamicCohortPreview.vue?vue&type=script&lang=js&"
export * from "./DynamicCohortPreview.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCohortPreview.vue?vue&type=style&index=0&id=10d08657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d08657",
  null
  
)

export default component.exports